import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

export const apiError = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg ?? "").filter(Boolean).join(" ");
  return String(d?.msg ?? d);
};

const seen = typeof window !== "undefined" && sessionStorage.getItem("mk-intro");
export const SHOW_INTRO = !seen;
export const INTRO_DELAY = SHOW_INTRO ? 1.9 : 0.2;
export const EASE = [0.16, 1, 0.3, 1];
